import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">The Catholic Church in France</p>
        <h1>Catholic France</h1>
        <p className="lede">
          Coverage of Catholic life, pilgrimage, and parish news across France -- from record-breaking youth pilgrimages to the historic shrines that have drawn Catholics for centuries.
        </p>
        <div className="cta-row">
          <a href="#pilgrimage">
            Pilgrimage Sites
          </a>
          <a href="#community" className="secondary">
            Church Life
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>A Pilgrimage Revival</h2>
          <p>
            The annual Paris-to-Chartres pilgrimage drew a record crowd for its 44th edition in 2026 -- nearly 20,000 walkers over three days, up from 19,000 in 2025, with participants from 22 countries.
          </p>
        </article>
        <article>
          <h2>Historic Shrines</h2>
          <p>
            France is home to some of Catholicism's most visited shrines: Lourdes, Lisieux, Chartres, Nevers, Paray-le-Monial, Lyon, La Salette, and Ars each draw pilgrims for distinct devotions and histories.
          </p>
        </article>
        <article>
          <h2>A Church of Uneven Strength</h2>
          <p>
            Catholic practice varies sharply by diocese -- Diocese of Nanterre reports roughly 60% of its population as Catholic, while Diocese of Saint-Denis reports around 43%, reflecting France's uneven religious geography.
          </p>
        </article>
      </section>

      <section className="section" id="structure">
        <h2>Dioceses & Current Bishops</h2>
        <p className="section-sub">France has 183 bishops, 12,870 priests, and 3,084 permanent deacons across its dioceses.</p>
        <div className="directory-list">
          <article className="directory-item">
            <h3>Diocese of Versailles</h3>
            <p>Bishop Luc Crepy, under Metropolitan Archbishop Laurent Ulrich</p>
          </article>
          <article className="directory-item">
            <h3>Diocese of Nanterre</h3>
            <p>Bishop Matthieu Rouge, under Archbishop Laurent Ulrich</p>
          </article>
          <article className="directory-item">
            <h3>Diocese of Saint-Denis</h3>
            <p>Bishop Etienne Guillet, under Archbishop Laurent Ulrich</p>
          </article>
          <article className="directory-item">
            <h3>Diocese of Blois</h3>
            <p>Bishop Francis Bestion, under Archbishop Vincent Jordy</p>
          </article>
        </div>
      </section>

      <section className="section" id="news">
        <h2>Latest News</h2>
        <p className="section-sub">Recent, sourced developments -- updated as new stories are verified.</p>
        <div className="news-list">
          <article className="news-item">
            <p className="news-date">January 2026</p>
            <h3>Paris province launches major catechumenate assembly</h3>
            <p>The dioceses of the Ecclesiastical Province of Paris opened an assembly on 'Catechumens and neophytes,' with an opening Mass celebrated by Archbishop Laurent Ulrich, prompted by a rise in adult baptisms.</p>
            <p className="news-source">Source: The Pillar (pillarcatholic.com)</p>
          </article>
          <article className="news-item">
            <p className="news-date">May 2026</p>
            <h3>Chartres pilgrimage draws record crowd</h3>
            <p>The 44th Paris-to-Chartres pilgrimage drew nearly 20,000 walkers over three days from 22 countries, up from 19,000 in 2025.</p>
            <p className="news-source">Source: Catholic World Report</p>
          </article>
        </div>
      </section>
    </div>
  );
}

export default App;
